import {ScormUtils} from "scorm/common/ScormUtils";
import {Assert} from "common/Assert";

function initializeMasteryScore( masteryScore, defaultValue ){

    if( !masteryScore ){
        return defaultValue;
    }

    const result = Number(masteryScore);
    return isNaN( result ) ? defaultValue : result;
}


export function ScormApiBase( masteryScoreOption ){

    let masteryScore = initializeMasteryScore( masteryScoreOption, 80 ),
        startTime = new Date();

    // revealing public api
    return {

        getMasteryScore : () => {
            return masteryScore;
        },

        getLapsedTime : () => {
            return ScormUtils.getLapsedTime( startTime );
        },

        commitSuspendData: ( lmsApi, courseScoData, onDataToLongError ) => {

            Assert.checkArgument( lmsApi );
            Assert.checkArgument( courseScoData );
            Assert.checkArgumentType( onDataToLongError, "function" );

            const currentSuspendDataOnLms = lmsApi.getValue("cmi.suspend_data");
            const suspendDataToCommit = courseScoData.get("cmi.suspend_data");

            if( suspendDataToCommit === currentSuspendDataOnLms ){
                return;
            }

            if( lmsApi.setValue("cmi.suspend_data", suspendDataToCommit) === "false" ) {
                return;
            }

            if (!courseScoData.checkSuspendDataSize()) {
                lmsApi.commit();
                const lmsReceivedSuspendData = lmsApi.getValue("cmi.suspend_data");
                if (lmsReceivedSuspendData.length !== suspendDataToCommit.length) {
                    lmsApi.setValue("cmi.suspend_data", currentSuspendDataOnLms);
                    onDataToLongError();
                }
            }
        }
    };
}
